import { Button, Flex, Grid, Popover, Typography } from 'antd';
import { DownOutlined, CopyOutlined, LikeOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import TsysLogo from 'assets/tsys.svg?react';
import DisplayValue from 'components/DisplayValue/DisplayValue';

const TsysIdentifiersContainer = styled(Flex)`
  border: var(--border);
  border-radius: var(--border-radius-sm);
  max-height: fit-content;
  padding: 0 var(--spacing-xs);
  word-wrap: keep-all;
  .ant-typography-copy {
    vertical-align: baseline;
  }
`;

const TsysIdentifiers = ({ simpleAccount }) => {
  const { xl } = Grid.useBreakpoint();

  const accountDataAvailable =
    simpleAccount?.externalAccountId || simpleAccount?.externalCustomerId;

  if (!accountDataAvailable) {
    return;
  }

  return xl ? (
    <TsysIdentifiersContainer gap="var(--spacing-xs)" align="center">
      <TsysLogo style={{ width: '3em', height: '1em' }} />
      {simpleAccount?.externalAccountId ? (
        <Typography.Text
          style={{
            fontSize: 'var(--font-size-sm)',
            fontWeight: 'var(--font-weight)',
          }}
          copyable={{
            text: `${simpleAccount?.externalAccountId}`,
            tooltips: [
              'Copy TSYS Account ID',
              <span key="copied-message">
                Copied TSYS Account ID <LikeOutlined />
              </span>,
            ],
            icon: [<CopyOutlined />, <CopyOutlined disabled={true} />],
          }}
        >
          Account: {simpleAccount?.externalAccountId}
        </Typography.Text>
      ) : null}
      {simpleAccount?.externalCustomerId ? (
        <Typography.Text
          style={{
            fontSize: 'var(--font-size-sm)',
            fontWeight: 'var(--font-weight)',
          }}
          copyable={{
            text: `${simpleAccount?.externalCustomerId}`,
            tooltips: [
              'Copy TSYS Customer ID',
              <span key="copied-message">
                Copied TSYS Customer ID <LikeOutlined />
              </span>,
            ],
            icon: [<CopyOutlined />, <CopyOutlined disabled={true} />],
          }}
        >
          Customer: {simpleAccount?.externalCustomerId}
        </Typography.Text>
      ) : null}
    </TsysIdentifiersContainer>
  ) : (
    <Popover
      trigger="click"
      placement="bottomRight"
      arrow={false}
      content={
        <Flex vertical={true} gap="var(--spacing)">
          <div>
            <DisplayValue label="Account ID" canCopy={true}>
              {simpleAccount?.externalAccountId}
            </DisplayValue>
          </div>
          <div>
            <DisplayValue label="Customer ID" canCopy={true}>
              {simpleAccount?.externalCustomerId}
            </DisplayValue>
          </div>
        </Flex>
      }
    >
      <Button size="small">
        <TsysLogo style={{ width: '3em', height: '1em' }} />
        <DownOutlined style={{ fontSize: 'var(--font-size-sm)' }} />
      </Button>
    </Popover>
  );
};

export default TsysIdentifiers;
